import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.test';

import { ActivityJson } from './microservices/json/Activity.json';
import { IdDescriptionJson } from './microservices/json/id-description.json';
import { IdResponse } from './microservices/response/id.response';
import { MicroResponse } from './microservices/response/micro.response';

@Injectable({ providedIn: 'root' })
export class ActivityService {
  private endpoint = environment.IDEMPIER_GATEWAY + '/v1/taxpayer/activity';
  private http = inject(HttpClient);

  get(activityId: number): Observable<MicroResponse<ActivityJson>> {
    return this.http.get<MicroResponse<ActivityJson>>(
      this.endpoint + `/${activityId}`,
    );
  }

  save(params: ActivityJson): Observable<MicroResponse<IdResponse>> {
    return this.http.post<MicroResponse<IdResponse>>(this.endpoint, params);
  }

  update(params: ActivityJson): Observable<MicroResponse<IdResponse>> {
    return this.http.put<MicroResponse<IdResponse>>(this.endpoint, params);
  }

  updateIsActive(params: any): Observable<MicroResponse<IdResponse>> {
    return this.http.put<MicroResponse<IdResponse>>(this.endpoint, params);
  }

  updateMainActivity(
    id: number,
    mainActivity: boolean,
  ): Observable<MicroResponse<any>> {
    return this.http.put<MicroResponse<any>>(
      this.endpoint + `/${id}/mainActivity`,
      { mainActivity: mainActivity },
    );
  }

  getIdLabel(taxpayerId: number): Observable<MicroResponse<ActivityJson>> {
    return this.http.get<MicroResponse<ActivityJson>>(
      this.endpoint + `/projection?fields=id&taxpayerId=${taxpayerId}`,
    );
  }

  getIdDescription(
    taxpayerId: number,
  ): Observable<MicroResponse<Array<IdDescriptionJson>>> {
    return this.http.get<MicroResponse<Array<IdDescriptionJson>>>(
      this.endpoint +
        `/projection?fields=taxpayerId,description&taxpayerId=${taxpayerId}`,
    );
  }

  delete(activityId: number): Observable<MicroResponse<boolean>> {
    return this.http.delete<MicroResponse<boolean>>(
      this.endpoint + `/${activityId}`,
    );
  }
}
